import { Fieldset as BaseFieldset } from '@base-ui/react/fieldset';
import * as stylex from '@stylexjs/stylex';
import '../../../../styles/tokens.stylex';
import { spacing } from '../../../../styles/tokens.stylex';
import { typography } from '../../../../styles/typography';
import { formStyles } from '../../form.styles';
type BaseUICompositeType<T> = {
  styles?: stylex.StyleXStyles;
} & T;
function Root(props: BaseUICompositeType<BaseFieldset.Root.Props>) {
  return <BaseFieldset.Root {...props} {...stylex.props(sx.fieldset, props.styles)} />;
}
function Legend(props: BaseUICompositeType<BaseFieldset.Legend.Props>) {
  return <BaseFieldset.Legend {...props} {...stylex.props(typography.label, formStyles.label, sx.label, props.styles)} />;
}
export const Fieldset = {
  Root,
  Legend
};
const sx = {
  fieldset: {
    kOIVth: "x3ybb33",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  label: {
    $$css: true
  }
};